import { render, staticRenderFns } from "./system-template-add-edit-dialog.vue?vue&type=template&id=64ea88bb&scoped=true"
import script from "./system-template-add-edit-dialog.vue?vue&type=script&lang=js"
export * from "./system-template-add-edit-dialog.vue?vue&type=script&lang=js"
import style0 from "./system-template-add-edit-dialog.vue?vue&type=style&index=0&id=64ea88bb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ea88bb",
  null
  
)

export default component.exports